import { createFileRoute } from "@tanstack/react-router";
import { MellanoLuukkuStockForecastView } from "src/tenantCustomizations/tenants/mellano/views/luukku/metrics/MellanoLuukkuStockForecastView.tsx";

export const Route = createFileRoute("/_authenticated/_shell/mellano/luukku/melamineStockForecast")({
	staticData: { title: "Varastoenn, melamiini", legacyViewKey: "mellanoLuukkuMelamineStockForecastView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <MellanoLuukkuStockForecastView type={"MELAMINE"} />;
}
